export const ARCHIVE_CHANNEL_TYPES = Object.freeze([
  'Channel::Whatsapp',
  'Channel::Api',
  'Channel::Telegram',
  // Stesso elenco di Conversations::Archive::CHANNEL_TYPES (backend).
  'Channel::Instagram',
  'Channel::Messenger',
]);

export const isArchiveChannel = (channelType) =>
  ARCHIVE_CHANNEL_TYPES.includes(channelType);

export const isConversationArchiveInbox = (inbox) =>
  isArchiveChannel(inbox?.channel_type);

export const isArchiveStatus = (status) =>
  status === 'open' || status === 'resolved';

export const getArchiveAction = (status) => ({
  status: status === 'resolved' ? 'open' : 'resolved',
  labelKey:
    status === 'resolved'
      ? 'CONVERSATION.ARCHIVING.UNARCHIVE'
      : 'CONVERSATION.ARCHIVING.ARCHIVE',
  icon: status === 'resolved' ? 'arrow-reply' : 'archive',
});

export const getArchiveErrorKey = (error) => {
  const code = error?.response?.data?.error;
  if (code === 'new_incoming_message') {
    return 'CONVERSATION.ARCHIVING.NEW_MESSAGE';
  }
  if (code === 'blocked_contact') {
    return 'CONVERSATION.ARCHIVING.BLOCKED_CONTACT';
  }
  return 'CONVERSATION.ARCHIVING.FAILED';
};

export const resolveArchiveRouteStatus = ({ inbox, query = {} } = {}) => {
  if (!isConversationArchiveInbox(inbox)) return null;
  return isArchiveStatus(query.status) ? query.status : 'open';
};

export const buildArchiveSubmenu = ({
  status = 'open',
  active = false,
  translate,
} = {}) =>
  ['open', 'resolved'].map((value) => ({
    key: value,
    action: 'status',
    status: value,
    icon: value === 'open' ? 'INBOX' : 'ARCHIVE',
    iconColor: '#4c5155',
    label: translate(
      `CONVERSATION.ARCHIVING.${value === 'open' ? 'CONVERSATIONS' : 'ARCHIVED'}`
    ),
    isActive: active && status === value,
  }));

// Dopo un'archiviazione riuscita la lista si e' gia' aggiornata da sola
// (stato cambiato nello store, riga tolta dalla vista, cache della inbox
// invalidata): serve solo un riallineamento silenzioso, senza svuotare la
// lista e rifarla da capo (la riga "salta" e riparte una chiamata visibile,
// segnalato da Lorenc il 15/09 su una inbox voice). Il reset completo
// resta per l'errore, quando lo stato locale non e' piu' affidabile.
export const ARCHIVE_LIST_REFRESH_MODE = Object.freeze({
  NONE: 'none',
  RESET: 'reset',
  SILENT: 'silent',
});

export const resolveArchiveListRefreshMode = ({
  conversationArchive = false,
  failed = false,
} = {}) => {
  if (!conversationArchive) return ARCHIVE_LIST_REFRESH_MODE.NONE;
  return failed
    ? ARCHIVE_LIST_REFRESH_MODE.RESET
    : ARCHIVE_LIST_REFRESH_MODE.SILENT;
};
